import ResearchSearch from "../components/Research/ResearchSearch.jsx";

const Research = () => {

	return <ResearchSearch />;
};

export default Research;
